module.exports = __webpack_public_path__ + "img/NZ.2f14781e.svg";